import { compact, Compactable } from '../guards/compact';
import { isEmpty } from '../guards/isEmpty';

export const hasOneElement = <T>(value: Compactable<T>[] | null | undefined): value is [T] => {
   return !isEmpty(value) && compact(value).length === 1;
};
